import { NgModule } from '@angular/core';
import { TrustHtmlPipe } from './trust-html/trust-html';
import { FormatDatePipe } from './format-date/format-date.pipe';
@NgModule({
	declarations: [TrustHtmlPipe, FormatDatePipe],
	imports: [],
	exports: [TrustHtmlPipe,FormatDatePipe]
})
export class PipesModule {}
